<template>
  <v-card class="bank__rating">
    <v-row>
      <v-col cols="5">
        <v-text-field v-model="params" label="Наименование параметра" />
      </v-col>
      <v-col cols="5">
        <v-text-field
          v-model="paramsDescription"
          label="Подпись под параметром"
        />
      </v-col>
      <v-col cols="1"
        ><v-btn class="success" @click="AddParams()"
          >Добавить Параметр</v-btn
        ></v-col
      >
    </v-row>
    <v-row>
      <v-col>
        <v-card
          v-for="(item, index) in ratingConfig"
          :key="index"
          class="mt-2 pt-2 pl-2"
        >
          <div class="rating_items">
            <v-text-field
              v-model="editName"
              label="Наименование параметра"
              v-if="nowEdit == index"
            />
            <span v-else>{{ item.name }}</span>
            <v-text-field
              v-model="editDescription"
              label="Наименование параметра"
              v-if="nowEdit == index"
            />
            <span v-else>{{ item.description }}</span>
            <v-rating
              v-model="item.rate"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$ratingFull"
              half-increments
              hover
              class="rating_star"
              disabled
            />
            <v-icon
              normal
              class="mr-2 removes"
              @click="edit(item, index)"
              v-if="nowEdit !== index"
              >edit</v-icon
            >
            <v-icon
              normal
              class="mr-2 removes"
              @click="saveEdit(item, index)"
              v-else
              >save</v-icon
            >
            <v-icon normal class="mr-2 removes" @click="remove(index)"
              >delete_forever</v-icon
            >
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
  <!-- <v-combobox
  v-model="selectBank"
  :items="payment_items"
  label="Методы оплаты"
  multiple
  dense
/> -->
</template>
<script>
export default {
  name: "bank__rating",
  // components: {Rating},
  data: () => ({
    params: "",
    paramsDescription: "",
    nowEdit: null,
    editName: "",
    editDescription: "",
  }),
  props: {},
  methods: {
    AddParams() {
      this.params &&
        this.paramsDescription &&
        this.$store.dispatch("SET_RATING_CONFIG", {
          params: this.params,
          paramsDescription: this.paramsDescription,
        });
      this.paramsDescription = "";
      this.params = "";
    },
    edit(item, index) {
      this.nowEdit = index;
      this.editName = item.name;
      this.editDescription = item.description;
    },
    async saveEdit() {
      const rate = this.DeepCopy(this.ratingConfig);
      const NewRate = [];
      for (let i in rate) {
        if (i == this.nowEdit) {
          NewRate[i] = {
            name: this.editName,
            description: this.editDescription,
            rate: rate[i].rate,
          };
        } else {
          NewRate[i] = { ...rate[i] };
        }
      }
      await this.$store.dispatch("EDIT_RATING_CONFIG", NewRate);
      this.nowEdit = null;
      this.editDescription = "";
      this.editName = "";
    },
    async remove(index) {
      const rate = this.DeepCopy(this.ratingConfig);
      const NewRate = rate.filter((item, id) => id !== index);
      await this.$store.dispatch("EDIT_RATING_CONFIG", NewRate);
    },
  },
  computed: {
    ratingConfig() {
      return this.$store.getters.ratingConfig;
    },
  },
  created() {
    this.$store.dispatch("GET_RATING_CONFIG");
  },
};
</script>
<style lang="sass" scoped>
.bank__rating
  padding: 20px
.rating_items
  display: grid
  align-items: center
  grid-template-columns: 1fr 3fr 1fr 40px 40px
.removes
  justify-self: flex-end
.rating_star
  justify-self: center
</style>
